import _stubTrue2 from "lodash/stubTrue";
import React from 'react';
import { IconButton } from 'swag-client-common/components/ui/icon-button';
import { handleOnEscapeAndEnterPressed } from 'swag-client-common/utils/ui.utils';
import classes from './filter-button.scss';
export const FilterButton = ({
  onClick,
  onClose
}) => {
  const handleKeyDown = event => {
    return handleOnEscapeAndEnterPressed({
      event,
      onEnterCallback: onClick,
      onEscapeCallback: onClose
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    tabIndex: 0,
    "aria-label": "Open filter"
  }, /*#__PURE__*/React.createElement(IconButton, {
    iconClassName: classes.icon,
    buttonClassName: classes.button,
    dataButton: "Filters",
    dataTooltip: "Filters",
    tooltipDirection: "right",
    tooltipClassName: classes.tooltip,
    onClick: _stubTrue2,
    isButtonTag: false
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.label
  }, "Filters"));
};